export const SITE = {
    name: "Konstantin.mobile.bg",
    nameShort: "Konstantin",
    tagline: "Premium Cars. Premium Experience.",
    subtitle:
        "Внимателно подбрани автомобили с проверена история, изключително състояние и прозрачна сервизна документация.",
    phone: "+359 887 444 432",
    phoneRaw: "+359887444432",
    email: "konstantin.bg.eood@gmail.com",
    address: "Петрич, България",
    addressFull: "Петрич, България",
    hoursWeekdays: "Пон – Пет: 09:00 – 19:00",
    hoursWeekend: "Събота и неделя: по уговорка",
    facebook: "https://www.facebook.com/konstantin.mobile.bg",
    mobileBg: "https://konstantin.mobile.bg/obiavi/busove",
    tiktok: "https://www.tiktok.com/@konstantinauto",
    googleMaps: "https://maps.google.com/?q=41.3964349,23.1776751",
    // Embedded map centered on real coordinates (Петрич)
    mapsEmbed:
        "https://www.google.com/maps?q=41.3964349,23.1776751&z=15&output=embed",
    foundedYear: 2022,
    totalSales: 700,
};

export const NAV_LINKS = [
    { label: "Начало", href: "/", section: "hero" },
    { label: "Автомобили", href: "/cars", section: "inventory" },
    { label: "Услуги", href: "/services", section: "services" },
    { label: "За нас", href: "/about", section: "about" },
    { label: "Отзиви", href: "/reviews", section: "testimonials" },
    { label: "Контакти", href: "/contact", section: "contact" },
];

export const FORMAT = {
    money: (n) => {
        if (n === null || n === undefined || n === 0) return "По запитване";
        return new Intl.NumberFormat("bg-BG", {
            style: "currency",
            currency: "EUR",
            maximumFractionDigits: 0,
        }).format(n);
    },
    km: (n) => new Intl.NumberFormat("bg-BG").format(n) + " км",
    hp: (n) => `${n} к.с.`,
};

export const FUEL_BG = {
    Petrol: "Бензин",
    Diesel: "Дизел",
    Hybrid: "Хибрид",
    Electric: "Електро",
    "Plug-in Hybrid": "Plug-in Hybrid",
    CNG: "Метан",
    LPG: "Газ/Бензин",
};
export const TRANS_BG = {
    Automatic: "Автоматик",
    Manual: "Ръчна",
    DSG: "DSG Автоматик",
};
export const BODY_BG = {
    Sedan: "Седан",
    Coupe: "Купе",
    SUV: "SUV",
    Convertible: "Кабрио",
    Hatchback: "Хечбек",
    Wagon: "Комби",
    Van: "Ван",
    Pickup: "Пикап",
};
